<template>
	<div>
		<ECommerceIncludedProduct
			v-if="hasBundle"
			:product="eCommerceProduct"
		/>
		<div
			class="description margin-top-l margin-bottom-l"
			v-if="campaignDescription"
			v-html="campaignDescription"
		></div>
		<div
			class="description margin-top-l margin-bottom-l"
			v-if="memberPriceDescription"
			v-html="memberPriceDescription"
		></div>
		<div
			class="description margin-bottom-m"
			v-html="description"
		></div>
		<LinkInline
			class="read-more"
			href="#details-tab=0"
			@click.prevent="scrollToDetails"
			>Les mer</LinkInline
		>
	</div>
</template>

<script>
import GizmoComponentMixin from "~/mixins/platform/GizmoComponentMixin.js";
import ECommerceProductMixin from "~/components/ecommerce/ECommerceProductMixin/ECommerceProductMixin.js";
import { mapState } from "vuex";

import { marked } from "marked";

export default defineNuxtComponent({
	name: "ECommerceProductDescription",
	mixins: [GizmoComponentMixin, ECommerceProductMixin],

	computed: {
		...mapState("ecommerce", ["product"]),
		description() {
			return this.content.description || marked.parse(this.product?.descriptionSummary);
		},
		campaignDescription() {
			return this.eCommerceProduct?.campaignData?.attributes?.["tneb-product-page-campaign-info"];
		},
		memberPriceDescription() {
			return this.eCommerceProduct?.memberPrice?.campaignData?.description;
		},
		hasBundle() {
			return (
				this.eCommerceProduct?.campaignData?.attributes?.includedItem ||
				this.eCommerceProduct?.campaignData?.attributes?.includeditem ||
				this.product?.memberPrice?.campaignData?.includedItem
			);
		},
	},

	methods: {
		scrollToDetails() {
			this.$store.commit("ecommerce/setDetailsTab", 0);
			document.getElementById("product-details").scrollIntoView({ behavior: "smooth" });
		},
		scrollToRatings() {
			if (this.product.swapTotalPrice) this.$store.commit("ecommerce/setDetailsTab", 3);
			else this.$store.commit("ecommerce/setDetailsTab", 2);
			document.getElementById("product-details").scrollIntoView({ behavior: "smooth" });
		},
	},
});
</script>

<style lang="scss" scoped>
h1 {
	margin-bottom: $spacing-xl;

	@include font-title-xl;
}

.read-more {
	font-weight: bold;
}

.description {
	@include font-text-s;

	:deep() {
		p + p {
			margin-top: $spacing-m;
		}

		// CSS for v-html
		h2 {
			margin-bottom: $spacing-m;

			@include font-title-l;
		}

		p {
			margin-bottom: $spacing-m;

			@include font-text-s;
		}

		ul {
			list-style-type: disc;

			li {
				margin-bottom: $spacing-m;

				@include font-text-s;
			}
		}

		strong {
			font-weight: bold;
		}
	}
}
</style>
